export class FeriadoFiltroParmDTO {
  ano: number;
}

export class FeriadoParmDTO {
  id: number;
  data: string;
  nome: string;
  recorrente: boolean
  tipo: string;
  uf: string;
  municipio: string;

}

export class ConflitoAgendaFiltros {
  idsLogins: number[];
  dataIni: string;
  dataFim: string;
  horaIni: string;
  horaFim: string;
  tipoAlterando: 'AV' | 'RV' | 'EA';
  idAlterando: number;
  idInstituicao: number;

}